import React from 'react';
import { FieldStatus } from './components/FieldStatus';
import { NoteStatus } from './components/NoteStatus';
import { FieldHoleStatus } from './components/FieldHoleStatus';
import { EditFieldBoundariesStatus } from './components/EditFieldBoundariesStatus';
import { SplitFieldStatus } from './components/SplitFieldStatus';
import { EditMergedFieldStatus } from './components/EditMergedFieldStatus';
import { Box, TextField, Typography } from '@mui/material';
import { DRAWING_MODES } from '../PolygonDrawingContext';

export const DrawingPopoverStatus = (props) => {
  const { drawingMode } = props;
  const renderFieldInput = (label, value, key, size, onChange, shouldValidateInput) => {
    const isEditing =
      drawingMode === DRAWING_MODES.SPLIT_FIELD_POLYGONS ||
      drawingMode === DRAWING_MODES.EDIT_MERGED_FIELD;

    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          mb: 2,
        }}
      >
        <Typography variant="subtitle2" style={{ marginBottom: 1 }}>
          {label}
        </Typography>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
          }}
        >
          <TextField
            variant="standard"
            value={isEditing ? value : label}
            onChange={(e) => onChange(key, e.target.value)}
            disabled={!isEditing}
            error={isEditing && shouldValidateInput && !value?.trim()}
            helperText={isEditing && shouldValidateInput && !value?.trim() ? 'Invalid' : ''}
            style={{ width: '75%' }}
          />
          {size && (
            <Typography
              variant="body2"
              style={{
                fontWeight: 'bold',
                color: '#2c3e50',
                marginTop: 12,
                marginLeft: 2,
              }}
            >
              {size} ha
            </Typography>
          )}
        </Box>
      </Box>
    );
  };

  switch (drawingMode) {
    case DRAWING_MODES.FIELD:
      return <FieldStatus {...props} />;

    case DRAWING_MODES.NOTE:
    case DRAWING_MODES.SELECT:
      return <NoteStatus {...props} />;

    case DRAWING_MODES.FIELD_HOLE:
      return <FieldHoleStatus {...props} />;

    case DRAWING_MODES.EDIT_FIELD_BOUNDARIES:
      return <EditFieldBoundariesStatus {...props} />;

    case DRAWING_MODES.SPLIT_FIELD:
    case DRAWING_MODES.SPLIT_FIELD_POLYGONS:
      return <SplitFieldStatus {...props} renderFieldInput={renderFieldInput} />;

    case DRAWING_MODES.EDIT_MERGED_FIELD:
      return <EditMergedFieldStatus {...props} renderFieldInput={renderFieldInput} />;

    default:
      return null;
  }
};
